import React from 'react';

interface Props {
  color?: string;
  className?: string;
  direction?: 'right' | 'left';
}

const ChevronIcon: React.FC<Props> = ({ color, className, direction }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="13"
    viewBox="-2 -2 16 26"
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke={color || 'currentColor' || '#1C2451'}
      strokeWidth="3.5"
      transform={direction === 'right' ? 'rotate(0 5.5 10.5)' : 'rotate(-180 5.5 10.5)'}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="9.864 10 .197 0" />
      <path d="M9.86363636,10 L0.196969697,20" />
    </g>
  </svg>
);

export default ChevronIcon;
